import actions from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-information/actions';

import {
    ADD_TRACKED_ERRORS,
    REMOVE_TRACKED_ERRORS,
} from '@gov.wa.lni/application.child-labor-complaint/source/utils';

export default () => ({
    state    : { trackedErrors: []},
    actions  : { ...actions },
    mutations: {
        ADD_TRACKED_ERRORS,
        REMOVE_TRACKED_ERRORS,
    },
});